module.exports = __webpack_public_path__ + "img/47.af202ac6.svg";